<template>
  <div class="main-content login">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Appointment</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="login-container appointment">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="border-1px p-25">
              <h4 class="text-theme-colored text-uppercase m-0">
                Appointment Pasien
              </h4>
              <div class="line-bottom mb-30"></div>
              <form
                id="register-form"
                name="register-form"
                class="mt-30"
                method="post"
                action
                novalidate="novalidate"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Nama Lengkap Pasien</label>
                      <input
                        name="name"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Masukkan Nama Lengkap"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Jenis Kelamin Pasien</label>
                      <select name="kelamin" class="form-control">
                        <option value>Masukkan Jenis Kelamin</option>
                        <option value="1">Laki-laki</option>
                        <option value="2">Perempuan</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <label>Tanggal Lahir</label>
                    <div class="row">
                      <div class="form-group mb-10 col-sm-4">
                        <select name="tgl" class="form-control">
                          <option value>Tanggal</option>
                          <option :key="n" v-for="n in 31" :value="n">{{
                            n
                          }}</option>
                        </select>
                      </div>
                      <div class="form-group mb-10 col-sm-4">
                        <select name="bln" class="form-control">
                          <option value>Bulan</option>
                          <option
                            :key="'month-' + n"
                            v-for="n in 12"
                            :value="n"
                            >{{ month[n - 1] }}</option
                          >
                        </select>
                      </div>
                      <div class="form-group mb-10 col-sm-4">
                        <select name="thn" class="form-control">
                          <option value="0">Tahun</option>
                          <option
                            :key="'year-' + year"
                            v-for="year in years"
                            :value="year"
                            >{{ year }}</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Alamat Pasien</label>
                      <textarea
                        name="alamat"
                        class="form-control required"
                        placeholder="Masukkan Alamat"
                        rows="5"
                        aria-required="true"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Email Pasien</label>
                      <input
                        name="email"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Masukkan Email Address"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>No. Tlp Pasien</label>
                      <input
                        name="tlp"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Masukkan No.Tlp"
                        aria-required="true"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 divider"></div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Poli</label>
                      <select name="poli" class="form-control">
                        <option value>Pilih Poli</option>
                        <option value="1">Poli Anak</option>
                        <option value="2">Poli Kandungan</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Tanggal Perjanjian</label>
                      <select name="tgl-janji" class="form-control">
                        <option value>Pilih Tanggal Perjanjian</option>
                        <option value="2-10-2019">02 Okt 2019</option>
                        <option value="3-10-2019">03 Okt 2019</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Dokter</label>
                      <select name="dokter" class="form-control">
                        <option value>Pilih Dokter</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Jadwal</label>
                      <select name="jadwal" class="form-control">
                        <option value>Pilih Jadwal</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group mb-10">
                      <label>Asuransi</label>
                      <select name="asuransi" class="form-control">
                        <option value>Pilih Asuransi</option>
                        <option value="1">Asuransi</option>
                        <option value="2">Umum</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0 mt-20">
                  <button
                    type="submit"
                    class="btn btn-circled btn-dark btn-theme-colored"
                  >
                    Daftar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-12 col-lg-2"></div>
          <div class="col-md-12 col-lg-4 mt-sm-20">
            <h4 class="text-theme-colored text-uppercase m-0">Hubungi Kami</h4>
            <div class="line-bottom mb-30"></div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="icon-box left media bg-deep p-30 mb-20">
                  <a href="javascript:;" class="media-left pull-left">
                    <i class="fa fa-hospital-o text-theme-colored"></i>
                  </a>
                  <div class="media-body">
                    <h5 class="mt-0">Alamat Rumah Sakit</h5>
                    <p>
                      Jl. Srandakan Km. 5,5, Pandak, Bantul. D.I Yogyakarta
                      55761
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="icon-box left media bg-deep p-30 mb-20">
                  <a href="javascript:;" class="media-left pull-left">
                    <i class="fa fa-ambulance text-theme-colored"></i>
                  </a>
                  <div class="media-body">
                    <h5 class="mt-0">Gawat Darurat IGD 24 Jam</h5>
                    <p>281-2111</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="icon-box left media bg-deep p-30 mb-20">
                  <a href="javascript:;" class="media-left pull-left">
                    <i class="fa fa-phone text-theme-colored"></i>
                  </a>
                  <div class="media-body">
                    <h5 class="mt-0">Hotline</h5>
                    <p>(0274) 2812-999</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="icon-box left media bg-deep p-30 mb-20">
                  <a href="javascript:;" class="media-left pull-left">
                    <i class="fa fa-envelope text-theme-colored"></i>
                  </a>
                  <div class="media-body">
                    <h5 class="mt-0">Email Address</h5>
                    <p>contact@rsuii.co.id</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Appointment",
  metaInfo: {
    title: "Appointment",
    meta: [
      { charset: "utf-8" },
      { property: "og:site_name", content: "RSUII Website" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "rsuii.co.id" },
      { property: "og:description", content: "RSUII Appointment" },
      {
        property: "og:title",
        vmid: "og:title",
        content: "RSUII Tentang Kami"
      },
      {
        vmid: "description",
        name: "description",
        content:
          "Struktur kepemilikan saham Rumah Sakit UII dimiliki oleh Yayasan Badan Wakaf Universitas Islam Indonesia."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content: "janji,appointment,rsuii,uii,universitas"
      }
    ]
  },
  computed: {
    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + index
      );
    }
  },
  data() {
    return {
      month: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Appointment.vue